import { Controller } from '../utils/controller';
import { LiveChatInit } from '../../vendor/livechat-init.min';

export default class extends Controller {
  static values = {
    brandCode: {
      type: String,
      default: ''
    },
    marketCode: {
      type: String,
      default: ''
    },
    languageCode: {
      type: String,
      default: ''
    },
    environment: {
      type: String,
      default: ''
    }
  };

  declare brandCodeValue: string;
  declare marketCodeValue: string;
  declare environmentValue: string;
  declare languageCodeValue: string;

  private async init(): Promise<void> {
    const brandCode = this.brandCodeValue;
    const marketCode = this.marketCodeValue;
    const languageCode = this.languageCodeValue;
    const environment = this.environmentValue;

    await LiveChatInit.init({ brandCode, marketCode, languageCode, environment });
  }

  connect(): void {
    this.init();
  }
}
